import { Component, Input } from '@angular/core';

export type PageShellWidth = 'full' | 'xl' | 'lg';

@Component({
  selector: 'lib-page-shell',
  standalone: true,
  template: `
    <section
      class="page-shell"
      [class.page-shell--full]="width === 'full'"
      [class.page-shell--xl]="width === 'xl'"
      [class.page-shell--lg]="width === 'lg'"
    >
      <ng-content />
    </section>
  `,
  styles: [`
    .page-shell {
      display: grid;
      gap: 14px;
      width: 100%;
      min-width: 0;
    }

    .page-shell--full {
      max-width: none;
    }

    .page-shell--xl {
      max-width: 1400px;
    }

    .page-shell--lg {
      max-width: 1200px;
    }
  `],
})
export class PageShellComponent {
  @Input() public width: PageShellWidth = 'full';
}
